export default "__VITE_ASSET__BsRHUCWL__"